import { serverBus } from '@/main'
import Global from '@/scripts/Global'
import SessionManager from '@/Manager/Session.manager'
import { CPUtils } from '@/scripts/Utils'
import UserSessionManager from '@/Manager/Session/Users.manager'
import ChannelApi from '@/scripts/api/channel.api'
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'UsersList',
    data (){
        return {
          showModal: false,
          mainSpinner: false,
          overlayType : Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE),
          organisationUsers: SessionManager.getUsers(),
          loggedInUserId: SessionManager.getLoggedInUserId(),
          usersSuggestion: [],
          noSuggestion: 'Start typing a username to get suggestions',
          seletedUserId: '',
          selectedChannel: '',
          selectedUserName: ''

        }
      },
    mounted() {

     serverBus.$on(VueSignals.OVERLAY_TYPE, (overlayType) => {
      this.overlayType = overlayType
     })

     serverBus.$on(VueSignals.SHOW_MODAL, (showModal) => {
      this.showModal = showModal
     })
     this.organisationUsers = CPUtils.RemoveLoggedInUser(this.organisationUsers)
     this.organisationUsers = UserSessionManager.FilterFromDirectChannel(this.organisationUsers)
     this.organisationUsers.sort(function(a,b){
        if(b.reachability == "online"){
          return 1
        }
        return -1
      })

    },
  methods: {
    closeModal(){
      this.showModal = false;
    },
    modalCall(){
      this.showModal = true;
    },
    suggest(id){
      this.usersSuggestion = []
      this.noSuggestion = ''
      this.invite_search = document.getElementById(id)
      let search_pattern = this.invite_search.value.toLowerCase()
      this.organisationUsers.forEach(currUser => {
        if(currUser.username.toLowerCase().indexOf(search_pattern) != -1){
          if(!this.usersSuggestion.some(filterUser=> {
            return filterUser.username.toLowerCase() == currUser.username.toLowerCase()
          }))
          this.usersSuggestion.push(currUser)
        }
        else if(currUser.email.toLowerCase().indexOf(search_pattern) != -1){
          if(!this.usersSuggestion.some(filterUser=> {
              return filterUser.email.toLowerCase() == currUser.email.toLowerCase()
            })){
            this.usersSuggestion.push(currUser)
          }
        }
      })

      if(search_pattern.length > 0 && this.usersSuggestion == 0){
        this.noSuggestion = "No one found matching \"" + search_pattern+ " \""
      }
      if(search_pattern === ''){
        this.noSuggestion = 'Start typing a username to get suggestions'
        this.usersSuggestion = []
      }
    },
    ChooseMessage(username, user_id, channel_id){
      this.seletedUserId = user_id
      this.selectedChannel = channel_id
      this.selectedUserName = username
      this.usersSuggestion = []
    },
    DirectMessage(){
        if(this.seletedUserId != SessionManager.getLoggedInUserId()){
          let channel = {}
          let external = false
          if(typeof this.selectedChannel != 'undefined' && this.selectedChannel  != ''){
            SessionManager.setActiveChannelById(this.selectedChannel)
          }else{
            if(CPUtils.hasEmail(this.selectedUserName)){
              this.seletedUserId = this.selectedUserName
              external = true
            }
          }
          ChannelApi.createDirect(this.seletedUserId).then(res => {
            if(res.data.result){
              if(external){
                res.data.channel.channel_name = this.selectedUserName
                res.data.channel.external = true
              }
              let invitaion_id= res.data.invitation_id
              res.data.invitaion_id = null
              SessionManager.UpdateExternalChannel(res.data.channel)
              // Refresh left side channels
              Global.globalValue(VueSignals.CHANNEL_LIST_CHANGED, true)
              SessionManager.setActiveChannel(res.data.channel)
              // SessionManager.setActiveChannelById(res.data.channel.channel_id)
            }else {
              if(res.data.reason == "channel_already_exists"){
                SessionManager.setActiveChannelById(res.data.channel_id)
              }
            }
          })
        Global.globalValue(VueSignals.OVERLAY_TYPE,'')
        Global.globalValue(VueSignals.SHOW_MODAL, false)
        }
    },
  }
}
